import React from 'react';
import "../../css/loader.scss";

const spinner = () => {
    return (
        <div>
            <br /><br /><br />
            <div class="epn-logo-pd">
                <div class="epn-logo-cust">
                    <div></div>
                    <div></div>
                    <img alt="excutive" class="epn-img-loader" width="50" src="/assets/images/eduplusnow_icon.jpg" />
                </div>
            </div>
        </div>
    );
};

export default spinner;